export default __webpack_public_path__ + "static/media/home_pic6.451664d6.png";